export function overridePreloader(theme) {
  theme.overrides.MuiSkeleton = {
    text: {
      borderRadius: '3px'
    }
  };
}